import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import BuddyInfo from './components/BuddyInfo';
import Register from './components/Register';
import Login from './components/Login';
import MagicLinkVerify from './components/MagicLinkVerify';
import ProfileEditor from './components/ProfileEditor';

import useSound from 'use-sound';
import startup from './windows-xp-startup.mp3';

import './App.css';
import 'xp.css';

function App() {
  const [play] = useSound(startup, {
		interrupt: true,
	});

  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <div className="desktop" onClick={() => play()}></div>
          <Routes>
            <Route path="/" element={<BuddyInfo />} />
            <Route path="/profile/:screenName" element={<BuddyInfo />} />
            <Route path="/register" element={<Register />} />
            <Route path="/login" element={<Login />} />
            <Route path="/magic-link/:token" element={<MagicLinkVerify />} />
            <Route path="/edit" element={<ProfileEditor />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
